import * as types from '../mutation-types';
import config from '@/config';
import { loadData } from '@/utils/loading';
import axios from 'axios';
import Vue from 'vue';


const state = {
  snapshots: null,
  currentSnapshot: null,
};

const mutations = {
  [types.SET_SNAPSHOTS]: (state, snapshots) => {
    state.snapshots = snapshots;
  },
  [types.SET_CURRENT_SNAPSHOT]: (state, snapshot) => {
    state.currentSnapshot = snapshot;
  },
};

const getters = {
};

const actions = {
  loadSnapshots({ commit, dispatch }) {
    const url = new URL(config.ICOOL.API.SNAPSHOTS_PATH, config.ICOOL.BACKEND_HOST).href;
    return new Promise((resolve, reject) => {
      loadData(commit, types.SET_SNAPSHOTS, url).then(() => {
        resolve();
      }, () => reject());
    });
  },
  setFirstAvailableSnapshotAsCurrent({ commit, state }) {
    const defaultSnapshot = state.snapshots.filter(s => s.is_default)[0];
    commit(types.SET_CURRENT_SNAPSHOT, defaultSnapshot || state.snapshots[0]);
  },
  async loadSnapshotData({ commit, dispatch, state }) {
    const url = new URL(
      config.ICOOL.API.PROJECTS_ACTIVE_SNAPSHOT_DATA(state.currentSnapshot.project),
      config.ICOOL.BACKEND_HOST,
    ).href;
    try {
      const response = await axios.get(url);
      commit(types.SET_CURRENT_SNAPSHOT, response.data.snapshot);
      dispatch('updateVarsValues', { varItems: response.data.data }, { root: true });
      dispatch('updateServices', { services: response.data.services }, { root: true });
      dispatch('updatePlaces', { places: response.data.places }, { root: true });
    } catch (err) {
      console.log('could not load snapshot data', err);
    }
  },
  SOCKET_SNAPSHOT_UPDATED({ commit, getters }, msg) {
    const data = JSON.parse(msg);
    Vue.$log.debug(data);
    commit(types.SET_CURRENT_SNAPSHOT, data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
